import type { CompanyGroupListItemResponseDto } from "@/spz-api/model";

export interface CompanyGroupListItem {
  id: string;
  name: string;
  description: string | null;
  companyCount: number;
  updatedAt: Date;
}

export class CompanyGroupMapper {
  static toListItem(
    dto: CompanyGroupListItemResponseDto,
  ): CompanyGroupListItem {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      companyCount: dto.companyCount,
      updatedAt: new Date(dto.updatedAt),
    };
  }

  static toListItems(
    dtos: CompanyGroupListItemResponseDto[],
  ): CompanyGroupListItem[] {
    return dtos.map(CompanyGroupMapper.toListItem);
  }
}
